import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {FeedbackPageContainer} from 'shells/billing/feedback-page/feedback-page-container';
import {FeedbackPageLayout} from 'shells/billing/feedback-page/feedback-page-layout';

import {CHURN_FORM_ANIMATION_SRC} from '../churn/consts';

import {CancelForm} from './cancel-form';
import {CancelPageSubmitted} from './cancel-page-submitted';
import type {CancelFormData} from './types';

export function CancelPage() {
    const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null | undefined>(null);

    const handleSubmit = (data: CancelFormData) => {
        setIsLoading(true);
        setError(null);

        formEncodedApi
            .post('/setup/billing/cancellation-form.json', {
                form: JSON.stringify(data),
            })
            .then(() => {
                setIsSubmitted(true);
            })
            .catch((err) => {
                setError(err.message || 'An error occurred while submitting the form.');
                setIsLoading(false);
            });
    };

    return (
        <FeedbackPageContainer>
            {isSubmitted ? (
                <CancelPageSubmitted />
            ) : (
                <FeedbackPageLayout
                    title='Nutshell cancellation form'
                    subtitle='We’re sorry to hear that you’d like to cancel, but we understand your decision. Your feedback is incredibly valuable to us as we work to make Nutshell even better. Would you mind sharing a few details with us to help us improve?'
                    animationSrc={CHURN_FORM_ANIMATION_SRC}
                    formComponent={
                        <CancelForm
                            onSubmit={handleSubmit}
                            isSubmitting={isLoading}
                            error={error}
                        />
                    }
                />
            )}
        </FeedbackPageContainer>
    );
}
